package com.gsb.vyapar.bhagya.presentation.auth.manager

import com.gsb.vyapar.bhagya.datasource.network.KtorClient
import com.gsb.vyapar.bhagya.datasource.preference.Preference
import com.gsb.vyapar.bhagya.domain.User
import com.gsb.vyapar.bhagya.domain.encodeUserString
import com.gsb.vyapar.bhagya.domain.getOtp
import com.gsb.vyapar.bhagya.domain.toUser
import com.gsb.vyapar.bhagya.getAppHash
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.getState
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.launchDefault
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.updateState
import com.gsb.vyapar.bhagya.interactor.util.hideLoading
import com.gsb.vyapar.bhagya.interactor.util.showError
import com.gsb.vyapar.bhagya.interactor.util.showLoading
import com.gsb.vyapar.bhagya.interactor.util.showSuccess
import com.gsb.vyapar.bhagya.presentation.Screens
import com.gsb.vyapar.bhagya.presentation.auth.event.AuthUiEvents
import com.gsb.vyapar.bhagya.presentation.auth.uistate.getAuthUiState
import com.gsb.vyapar.bhagya.presentation.auth.util.*
import com.gsb.vyapar.bhagya.presentation.navigation.util.checkUserAfterLogin
import com.gsb.vyapar.bhagya.presentation.navigation.util.popView
import com.gsb.vyapar.bhagya.presentation.navigation.util.pushView
import com.gsb.vyapar.bhagya.util.BuildConfig
import com.gsb.vyapar.bhagya.util.HASH_OTP
import com.gsb.vyapar.bhagya.util.PlatformType
import com.gsb.vyapar.bhagya.util.getRandomIntString
import com.gsb.vyapar.bhagya.util.isValidEmail
import com.gsb.vyapar.bhagya.util.isValidMobileNumber
import com.gsb.vyapar.bhagya.util.toU
import com.gsb.vyapar.bhagya.util.value
import kotlinx.coroutines.delay
import kotlin.random.Random

object AuthManager {
    fun onTriggerEvent(event: AuthUiEvents) {
        when (event) {
            is AuthUiEvents.SendEmailOtp -> {
                if (!isValidEmail(event.email)) {
                    showError("Enter valid Email")
                    return
                }
                val genOtp = getRandomIntString()
                val genOtpEmail = event.email
                requestOtpEmail(
                    genOtpEmail,
                    "One Time Password (OTP) for your GSB-VyaparBhagya account",
                    getState().getInfo().getOtp().replace("%OTP%", genOtp).replace("%EMAIL%", genOtpEmail)) { result ->
                    if (result.isSuccess) {
                        getAuthUiState().sendEmailOtpSuccess(genOtp, genOtpEmail)
                        startTimer()
                    }
                }
            }
            is AuthUiEvents.SendMobileOtp -> {
                if (!isValidMobileNumber(event.mobile)) {
                    showError("Enter valid mobile number")
                    return
                }
                val genOtp = getRandomIntString()
                val genOtpMobile = event.mobile
                requestOtpMobile(
                    genOtpMobile,
                    "Your OTP is: $genOtp" + if (BuildConfig.platform() == PlatformType.ANDROID) "\n${getAppHash()}" else "",
                ) { result ->
                    if (result.isSuccess) {
                        getAuthUiState().sendMobileOtpSuccess(genOtp, genOtpMobile)
                        startTimer()
                    }
                }
            }

            is AuthUiEvents.VerifyOtp -> {
                val genOtp = getAuthUiState().genOtp
                if (genOtp == event.otp) {
                    showSuccess("OTP verified")
                    popView()
                    if (getAuthUiState().isEmail) {
                        getAuthUiState().genOtpEmail?.let {
                            saveUserEmail(it) {
                                pushView(Screens.Register)
                            }
                        }
                    } else {
                        getAuthUiState().genOtpMobile?.let {
                            showLoading()
                            launchDefault {
                                val result = KtorClient.getUser(it.toU())
                                hideLoading()
                                if (result.isSuccess) {
                                    updateState(getState().copy(user = result.getOrNull()?.toUser()?.encodeUserString() ?: User().encodeUserString()))
                                    Preference.user = getState().user
                                    checkUserAfterLogin()
                                } else {
                                    saveUserMobile(it) {
                                        checkUserAfterLogin()
                                    }
                                }
                            }
                        }
                    }
                } else {
                    showError("OTP mismatch, Try Again")
                }
            }
        }
    }

    private fun startTimer() {
        getAuthUiState().setTimerEnabled(true)
        launchDefault {
            getAuthUiState().setRemainingTime(getAuthUiState().remainingTime - 1)
            while (getAuthUiState().remainingTime in 1..119 && getAuthUiState().timerEnabled) {
                delay(1000)
                getAuthUiState().setRemainingTime(getAuthUiState().remainingTime - 1)
            }
        }
    }
}